<template>
  <div>
    <md-autocomplete
      :class="[
        { 'md-valid': !errors.has(name) && touched },
        { 'md-error': errors.has(name) }
      ]"
      :id="name"
      :name="name"
      :data-vv-name="name"
      :md-options="options"
      :disabled="disabled"
      v-model="inputValue"
      v-validate="validationRules"
      @md-changed="updateValue"
    >
      <label>{{ $t(label) }}</label>
    </md-autocomplete>
    <p v-if="errors.has(name)" class="text-danger">
      {{ errors.first(name) }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    validationRules: [String, Object],
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      inputValue: this.value || "",
      touched: false
    };
  },
  watch: {
    value(val) {
      this.inputValue = val;
      this.touched = true;
    }
  },
  methods: {
    updateValue() {
      this.$emit("input", this.inputValue);
    }
  },
  inject: {
    $validator: "$validator"
  }
};
</script>
